import React from 'react'

export default function Head() {
    return (
        <div style={{ borderBottom: '2px solid #12285d', height: '50px', background: 'rgba(6,12,64,1)', color: 'white', fontSize: '18px', lineHeight: '50px', padding: '0 40px',}}>
            基座管理系统
        </div>
    )
}
